import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/login/login';
import ErrorPage from './components/errorPage/errorPage';
import HomePage from './components/homePage/homePage';
import PortfolioPage from './components/portfolioPage/portfolioPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/homepage" element={<HomePage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/error" element={<ErrorPage />} />  
      </Routes>
    </Router>
  );
};

export default App;
